import { type Bank, type BanksMap } from '../model';

export const buildBanksMap = (banks: readonly Bank[]): BanksMap => {
    const result = new Map<string, Bank>();

    for (const bank of banks) {
        const { code } = bank;

        if (typeof code !== 'string' || code.trim().length === 0) {
            continue;
        }

        result.set(code, {
            ...bank,
            code,
        });
    }

    return result;
};
